export default __webpack_public_path__ + "static/media/userProfileDefault.88d72df8.svg";